import React, { Component } from "react";
import Slider from "react-slick";

//import Load from "../../assets/svg/other/loading2.svg";

// import "../../../node_modules/slick-carousel/slick/slick.css";
// import "../../../../node_modules/slick-carousel/slick/slick-theme.css";

// Import css files
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// import Chart from 'chart.js';
import Bitgraph from "./btcGraph";
import Ethgraph from "./ethGraph";
import Xlmgraph from "./xlmGraph";
import Xrpgraph from "./xrpGraph";
import Celograph from "./celoGraph";
import Usdcgraph from "./usdcGraph";

//
import Bitcoin from "../../assets/svg/other/bitcoin.svg";
import Eth from "../../assets/svg/other/eth.svg";
import XLM from "../../assets/svg/other/xlm.svg";
import XRP from "../../assets/svg/other/xrp.svg";
import Celo from "../../assets/svg/other/celo.svg";
import Usdt from "../../assets/svg/icons-new/page/usdt.svg";
import Usdc from "../../assets/svg/icons-new/page/usdc.svg";
import Cusd from "../../assets/svg/icons-new/page/cisd.svg";

export default class bitGraphs2 extends Component {
  // constructor(props) {
  //   super(props);
  //   this.next = this.next.bind(this);
  //   this.previous = this.previous.bind(this);
  // }
  // next() {
  //   this.slider.slickNext();
  // }
  // previous() {
  //   this.slider.slickPrev();
  // }
  state = {
    bitgraph: true,
    ethgraph: false,
    xlmgraph: false,
    xrpgraph: false,
    celograph: false,
    usdtgraph: false,
    cusdgraph: false,
    usdcgraph: false,
    isLoaded: false,
  };

  //bitcoin,ethereum,ripple,stellar,celo,celo-dollar,tether,usd-coin

  handleBit = () => {
    this.setState({
      bitgraph: true,
      ethgraph: false,
      xlmgraph: false,
      xrpgraph: false,
      celograph: false,
      usdtgraph: false,
      usdcgraph: false,
      cusdgraph: false,
    });
  };
  handleEth = () => {
    this.setState({
      bitgraph: false,
      ethgraph: true,
      xlmgraph: false,
      xrpgraph: false,
      celograph: false,
      usdtgraph: false,
      usdcgraph: false,
      cusdgraph: false,
    });
  };
  handleXlm = () => {
    this.setState({
      bitgraph: false,
      ethgraph: false,
      xlmgraph: true,
      xrpgraph: false,
      celograph: false,
      usdtgraph: false,
      usdcgraph: false,
      cusdgraph: false,
    });
  };
  handleXrp = () => {
    this.setState({
      bitgraph: false,
      ethgraph: false,
      xlmgraph: false,
      xrpgraph: true,
      celograph: false,
      usdtgraph: false,
      usdcgraph: false,
      cusdgraph: false,
    });
  };
  handleCelo = () => {
    this.setState({
      bitgraph: false,
      ethgraph: false,
      xlmgraph: false,
      xrpgraph: false,
      celograph: true,
      usdtgraph: false,
      usdcgraph: false,
      cusdgraph: false,
    });
  };
  // handleUsdt = () => {
  //   this.setState({
  //     bitgraph: false,
  //     ethgraph: false,
  //     xlmgraph: false,
  //     xrpgraph: false,
  //     celograph: false,
  //     usdtgraph: true,
  //     usdcgraph: false,
  //     cusdgraph: false,
  //   });
  // };
  handleUsdc = () => {
    this.setState({
      bitgraph: false,
      ethgraph: false,
      xlmgraph: false,
      xrpgraph: false,
      celograph: false,
      usdtgraph: false,
      cusdgraph: false,
      usdcgraph: true,
    });
  };
  // handleCusd = () => {
  //   this.setState({
  //     bitgraph: false,
  //     ethgraph: false,
  //     xlmgraph: false,
  //     xrpgraph: false,
  //     celograph: false,
  //     usdtgraph: false,
  //     usdcgraph: false,
  //     cusdgraph: true,
  //   });
  // };

  render() {
    const settings = {
      // dots: false,
      // infinite: true,
      // speed: 1000,
      // slidesToShow: 4,
      // slidesToScroll: 1,
      // arrows:false,

      // pauseOnHover: true

      // dots: true,
      // infinite: true,
      // speed: 500,
      // slidesToShow: 4,
      // slidesToScroll: 1

      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 1,
      focusOnSelect: false,
      autoplay: true,
      autoplaySpeed: 4000,
      arrows: false,
      responsive: [
        // {
        //   breakpoint: 1024,
        //   settings: {
        //     slidesToShow: 3,
        //     slidesToScroll: 3,
        //     infinite: true,
        //     dots: true
        //   }
        // },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
            initialSlide: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
      ],
    };
    const { selectedCurrency } = this.props;
    return (
      <div>
        <div className="home-box-bg-data">
          <div className="hbb-data-top">
            <Slider {...settings} className="hbb-data-top-layer">
              {/* <Slider  {...settings}> */}
              {this.state.bitgraph ? (
                <div className="hbb-outer">
                  <div
                    className="hbb-data-coin coin-active"
                    onClick={this.handleBit}
                  >
                    <img src={Bitcoin} alt="data" />
                  </div>
                </div>
              ) : (
                <div className="hbb-outer">
                  <div className="hbb-data-coin" onClick={this.handleBit}>
                    <img src={Bitcoin} alt="data" />
                  </div>
                </div>
              )}
              {this.state.ethgraph ? (
                <div className="hbb-outer">
                  <div
                    className="hbb-data-coin coin-active"
                    onClick={this.handleEth}
                  >
                    <img className="eth-img" src={Eth} alt="data" />
                  </div>
                </div>
              ) : (
                <div className="hbb-outer">
                  <div className="hbb-data-coin" onClick={this.handleEth}>
                    <img className="eth-img" src={Eth} alt="data" />
                  </div>
                </div>
              )}
              {this.state.xlmgraph ? (
                <div className="hbb-outer">
                  <div
                    className="hbb-data-coin coin-active"
                    onClick={this.handleXlm}
                  >
                    <img src={XLM} alt="data" />
                  </div>
                </div>
              ) : (
                <div className="hbb-outer">
                  <div className="hbb-data-coin" onClick={this.handleXlm}>
                    <img src={XLM} alt="data" />
                  </div>
                </div>
              )}
              {this.state.xrpgraph ? (
                <div className="hbb-outer">
                  <div
                    className="hbb-data-coin coin-active"
                    onClick={this.handleXrp}
                  >
                    <img src={XRP} alt="data" />
                  </div>
                </div>
              ) : (
                <div className="hbb-outer">
                  <div className="hbb-data-coin" onClick={this.handleXrp}>
                    <img src={XRP} alt="data" />
                  </div>
                </div>
              )}
              {this.state.celograph ? (
                <div className="hbb-outer">
                  <div
                    className="hbb-data-coin coin-active"
                    onClick={this.handleCelo}
                  >
                    <img src={Celo} alt="data" />
                  </div>
                </div>
              ) : (
                <div className="hbb-outer">
                  <div className="hbb-data-coin" onClick={this.handleCelo}>
                    <img src={Celo} alt="data" />
                  </div>
                </div>
              )}
              {/* {this.state.usdcgraph ? (
              <div className="hbb-outer">
              <div
                className="hbb-data-coin coin-active"
                onClick={this.handleUsdc}
              >
                <img src={Usdc} alt="data" />
                <p className="sm-coin-names" >USDC</p>
              </div>
              </div>
            ) : ( */}
              <div className="hbb-outer">
                <div className="hbb-data-coin">
                  <img src={Usdc} alt="data" />
                  <p className="sm-coin-names">USDC</p>
                </div>
              </div>
              {/* )} */}

              {/* {this.state.cusdgraph ? (
             <div className="hbb-outer">
              <div
                className="hbb-data-coin coin-active"
                onClick={this.handleCusd}
              >
                <img src={Cusd} alt="data" />
                <p className="sm-coin-names" >cUSD</p>
              </div>
              </div>
            ) : ( */}
              <div className="hbb-outer">
                <div className="hbb-data-coin">
                  <img src={Cusd} alt="data" />
                  <p className="sm-coin-names">cUSD</p>
                </div>
              </div>
              {/* )} */}
              {/* {this.state.usdtgraph ? (
             <div className="hbb-outer">
              <div
                className="hbb-data-coin coin-active"
                onClick={this.handleUsdt}
              >
                <img src={Usdt} alt="data" />
                <p className="sm-coin-names" >USDT</p>
              </div>
              </div>
            ) : ( */}
              <div className="hbb-outer">
                <div className="hbb-data-coin">
                  <img src={Usdt} alt="data" />
                  <p className="sm-coin-names">USDT</p>
                </div>
              </div>
              {/* )} */}
            </Slider>
            {/* <div className="hbb-data-top-layer">



            </div> */}
          </div>
          {this.state.bitgraph === true && (
            <Bitgraph selectedCurrency={selectedCurrency} />
          )}
          {this.state.ethgraph === true && (
            <Ethgraph selectedCurrency={selectedCurrency} />
          )}
          {this.state.xlmgraph === true && (
            <Xlmgraph selectedCurrency={selectedCurrency} />
          )}
          {this.state.xrpgraph === true && (
            <Xrpgraph selectedCurrency={selectedCurrency} />
          )}
          {this.state.celograph === true && (
            <Celograph selectedCurrency={selectedCurrency} />
          )}
          {this.state.usdcgraph === true && (
            <Usdcgraph selectedCurrency={selectedCurrency} />
          )}
        </div>
      </div>
    );
  }
}
